import { safeAudioUrl } from "./subsplash-audio";

const escape = (value: unknown) =>
  String(value ?? "").replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        c
      ]!,
  );

export function renderMediaPlayer(entry: {
  title: string;
  content: string;
  compact_audio?: unknown;
  audio_url?: string;
}) {
  const native = `<iframe class="media-player" scrolling="no" title="${escape(entry.title)}" src="${escape(entry.content)}" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" sandbox="allow-scripts allow-same-origin allow-presentation" allowfullscreen loading="lazy"></iframe>`;
  const audio = entry.compact_audio && safeAudioUrl(entry.audio_url);
  return audio
    ? `<div class="compact-audio-player"><audio controls preload="metadata" aria-label="${escape(entry.title)}" src="${escape(audio)}"></audio><button type="button" class="native-player-switch">Use Subsplash player</button><template>${native}</template></div>`
    : native;
}

export const compactAudioCss = `.compact-audio-player{display:flex;flex-direction:column;align-items:stretch;gap:6px;width:100%;min-width:0;max-width:100%}.compact-audio-player audio{display:block;width:100%;max-width:100%;height:54px;min-height:54px}.compact-audio-player .native-player-switch{align-self:flex-end;background:transparent;color:inherit;font:inherit;font-size:12px;border:0;border-radius:4px;padding:8px;min-height:44px;text-decoration:underline;cursor:pointer}.compact-audio-player .native-player-switch:focus-visible{outline:2px solid currentColor;outline-offset:2px}`;
